import { tr } from "../../lib/i18n";
import { formatMoney, formatNumber } from "../../lib/settings";
import { useAnimatedNumber } from "../../lib/motion";

function Num({ value, money, settings, testid }) {
  const v = useAnimatedNumber(value, 600);
  return <bdi className="ds-big" data-testid={testid}>{money ? formatMoney(Math.round(v), settings) : formatNumber(Math.round(v))}</bdi>;
}

// 3–4 plain number rows, no boxed cards. Numbers count up once.
export const MonthNumbers = ({ rows, settings }) => (
  <div data-testid="month-numbers">
    {rows.map((r) => (
      <div key={r.key} className="ds-row" style={{ justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap" }}>
        <span className="text-sm" style={{ color: "var(--ds-ink-muted)" }}>{r.label}</span>
        <Num value={r.value} money={r.money} settings={settings} testid={`month-${r.key}`} />
      </div>
    ))}
  </div>
);

export const TargetLine = ({ target }) => {
  if (!target) return null;
  const pct = Math.max(0, Math.min(100, Math.round(target.percent || 0)));
  return (
    <div data-testid="target-line">
      <div className="flex justify-between text-sm mb-2 gap-3 flex-wrap">
        <span>{tr("lot.target")}</span>
        <span className="num-display" style={{ fontSize: 16 }}>
          {target.cars ? tr("lot.target_cars", { a: target.achieved_cars || 0, b: target.cars }) : ""} <bdi>{pct}%</bdi>
        </span>
      </div>
      <div className="ds-progress" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100} aria-label={tr("lot.target")}>
        <span style={{ width: `${pct}%`, background: pct >= 100 ? "var(--ds-green)" : "var(--ds-ink)" }} />
      </div>
    </div>
  );
};
